import styled from 'styled-components'

import { palette } from '../../theme/palette'
import {
  CloseWidgetContent,
  CloseWidgetButtonsContainer,
  CloseWidgetButton
} from '../closeWidgetModal/CloseWidgetModal.style'

export const ChangeLanguagePaper = styled.div`
  border-radius: 10px;
  background: ${palette.white};
  width: 100%;
  box-sizing: border-box;
  outline: none;
  padding: 32px;
`

export const ChangeLanguageContent = styled(CloseWidgetContent)`

`

export const ChangeLanguageButtonsContainer = styled(CloseWidgetButtonsContainer)`

`

export const ChangeLanguageButton = styled(CloseWidgetButton)`

`
